import axios from "axios";


export const dataApi = axios.create({
  baseURL: `${process.env.REACT_APP_DATA_API_URL}/api/`,
  timeout: 15000
});
